import request from 'superagent';
import config from '../config';
import moment from 'moment';

const API_URL = config.serverUrl;

const getFieldType = (fields, key) => {

  for (let i = 0; i < fields.length; i++) {
    if (fields[i].property === key) {
      return fields[i].type;
    }
  }

  return null;

};

const formDataFromItem = (item, fields) => {
  let form = new FormData();

  Object.keys(item).forEach(key => {
    const type = getFieldType(fields, key);
    if (type && type === 'date') {
      form.append(key, moment(item[key]).toISOString());
    }
    else {
      form.append(key, item[key]);
    }

  });

  return form;
};

module.exports = {

  getItems(modelName, query, sort) {
    return new Promise((resolve, reject) => {
      request
        .get(`${API_URL}/${modelName}`)
        .withCredentials()
        .set('Content-Type', 'application/json')
        .query('where=' + (query ? JSON.stringify(query) : '') + '&sort=' + (sort ? sort : ''))
        .end(function(err, resp) {
          console.log('Response status code: ', resp.statusCode);
          console.log('Response: ', resp);

          if (resp.statusCode === 302) {
            window.location = '/login';
            return resolve([]);
          }

          if (err) {
            return reject(err);
          }

          return resolve(resp.body);
        });
    });
  },

  createItem(modelName, item, path, fields) {
    path = path ? path : `${modelName}`;

    const form = formDataFromItem(item, fields);

    return new Promise((resolve, reject) => {
      request
        .post(`${API_URL}/${path}`)
        .withCredentials()
        .send(form)
        .end(function(err, resp) {
          if (err) {
            return reject(err);
          }

          return resolve(resp.body);
        });
    });
  }
};




// WEBPACK FOOTER //
// ./src/services/modelservice.js